import { MapTo } from '@adobe/cq-react-editable-components';
import Loadable from '../../../../utils/loadable';

const brtc = Loadable(() => import('../containers/brtcContainers'));
export default MapTo('vcg/components/soe-home/react/d2d/brtc')(brtc);
